import { Button, Tooltip } from "antd";
import { checkPermissions } from "@comps/commonFunctions";


const BaseCustomButton = ({ modkey, permissionAction, notify, text: buttonText, children, ...props }) => {
  if (modkey && permissionAction && !checkPermissions(modkey, permissionAction)) {
    return null;
  }

  const text = buttonText ? buttonText : children;
  let icon = null;

  return (
    <Tooltip { ...notify }>
      <Button { ...props } className="custom-button">
        <span>{ text } </span>
        { icon }
      </Button>
    </Tooltip>
  );
};

BaseCustomButton.displayName = "BaseCustomButton";

export default BaseCustomButton;
